import React from 'react'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import MyAutoComplete from '../../../../components/inputs/MyAutoComplete';
import MyNumberInput from '../../../../components/inputs/MyNumberInput';
import { myApi } from '../../../../config/axiosConfig';


const CrearEditarTollModal = ({ open, onClose, refresh, toll, isEditing, states }) => {

    // Opciones de estados
    const stateOptions = states.map(s => ({
        value: s.code,
        label: s.name
    }));

    // Opciones de ciudades dinámicas según el estado seleccionado
    const getCityOptions = (stateCode) => {
        const state = states.find(s => s.code === stateCode);
        return state ? state.cities.map(city => ({ value: city, label: city })) : [];
    };

    const validationSchema = Yup.object({
        City: Yup.string().required('Campo obligatorio'),
        State: Yup.string().required('Campo obligatorio'),
        Latitude: Yup.number()
            .typeError('La latitud debe ser un número')
            .required('Campo obligatorio')
            .test(
                'is-valid-lat',
                'La latitud debe estar entre -90 y 90',
                (value) => value >= -90 && value <= 90
            ),
        Longitude: Yup.number()
            .typeError('La longitud debe ser un número')
            .required('Campo obligatorio')
            .test(
                'is-valid-lng',
                'La longitud debe estar entre -180 y 180',
                (value) => value >= -180 && value <= 180
            ),
        NotAutorized: Yup.string().required('Campo obligatorio'),
    });

    const initialValues = {
        City: toll?.City || '',
        State: toll?.State || '',
        Latitude: toll?.Latitude || null,
        Longitude: toll?.Longitude || null,
        NotAutorized: toll?.NotAutorized || '',
        id: toll?.id || null,
    };

    const handleSubmit = async (values) => {

        try {
            if (isEditing) {
                await myApi.put(`/tolls/updateTolls/${toll.id}`, values);
            }
        } catch (error) {
            console.error('Error:', error);
        }

        refresh();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{isEditing ? 'Editar Toll' : 'Crear Toll'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ handleSubmit, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={6} sx={{ marginTop: 1 }}>
                                    <MyAutoComplete
                                        name="State"
                                        label="Estado"
                                        options={stateOptions}
                                    />
                                </Grid2>
                                <Grid2 size={6} sx={{ marginTop: 1 }}>
                                    <MyAutoComplete
                                        name="City"
                                        label="Ciudad"
                                        options={getCityOptions(values.State)}
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <MyNumberInput
                                        name="Latitude"
                                        label="Latitud"
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <MyNumberInput
                                        name="Longitude"
                                        label="Longitud"
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <MyAutoComplete
                                        name="NotAutorized"
                                        label="No Autorizado"
                                        options={[{ value: 'A', label: 'A - Autorizado' }, { value: 'NA', label: 'N/A - No Autorizado' }]}
                                    />
                                </Grid2>
                            </Grid2>
                            <DialogActions sx={{ justifyContent: 'flex-end' }}>
                                <Button type="submit" variant="contained" color="primary">
                                    Guardar
                                </Button>
                                <Button onClick={onClose}>Cancelar</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarTollModal